import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems, transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-166" data-mp="2ww2p8roo2zvm">
      <Reveal className="mx-auto max-w-5xl" data-id="element-167" data-mp="2rz2isfnwnv3z">
        <div className="mx-auto max-w-3xl text-center" data-id="element-168" data-mp="2ryayw23o7ltj">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-169" data-mp="2nx7h3a22bfpo">A BETTER WAY TO TEACH MATH</p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-blue md:text-5xl" data-id="element-170" data-mp="2j5h2ut0087sz">
            From an Overwhelmed Math Teacher to a{' '}
            <span className="italic text-brand-purple" data-id="element-171" data-mp="298bbrkre4gsr">Confident Math Guide.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-172" data-mp="248qd7bg4uagk">
            Every math hour can feel like a scramble — hunting for worksheets, re-explaining the same steps, and
            second-guessing whether the year actually adds up. Math Ready hands you the entire year, already built, so
            you can stop prepping and start teaching.
          </p>
        </div>
        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-173" data-mp="5delu8jno7rs">
          {transformationStats.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-174" data-mp="xzh77kno2ra8">
              <strong className="block font-serif text-3xl leading-none text-brand-orange" data-id="element-175" data-mp="12zc17x2qnwzi">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-176" data-mp="p0cbsn7eje2a">
                {label}
              </span>
            </div>)}
        </div>
        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(22,56,107,0.10)]" data-id="element-177" data-mp="39pjmzij45jd1">
          <div className="grid md:grid-cols-2" data-id="element-178" data-mp="1k9zf6ci1zlok">
            <Comparison title="BEFORE" items={beforeItems} positive={false} data-id="element-179" data-mp="1k8o1nkyt2zk9" />
            <Comparison title="WITH MATH READY" items={afterItems} positive data-id="element-180" data-mp="1famhewpn8u77" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-181" data-mp="1ajnxln5g5dz7">
            A complete math curriculum that helps you prepare less and teach with more confidence.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#f5f0e8]'}`} data-id="element-182" data-mp="rn4ylqocx6gd">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-183" data-mp="2lzkxu7iqjkbq">
        <div data-id="element-184" data-mp="2h08c5q3lojaq">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} data-id="element-185" data-mp="2gzqbmh9wnix0">
            {positive ? 'THE READY-TO-TEACH SYSTEM' : 'THE OLD WAY OF TEACHING MATH'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-blue" data-id="element-186" data-mp="2th13at80jcwh">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-187" data-mp="2ybwu5q1iju80">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-188" data-mp="26kh7xx3vc9ib" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-189" data-mp="2ak9n4snrpdwn">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-190" data-mp="2fi1dvjcoetz9">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-191" data-mp="3qyhwfljj1qqc" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-192" data-mp="3vwjf45d1jo1a">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}